import { useCallback, useEffect, useRef } from 'react';
import track from 'app/utils/dio/registration-page';
import config from 'config';

const gcpClientId = config.googleClientId;

function GoogleSignUpButton({ onSignup, width = 0 }) {
  const signInBtn = useRef();

  const initializeSignInButton = useCallback(() => {
    window.google.accounts.id.initialize({
      client_id: gcpClientId,
      callback: onSignup,
    });
    window.google.accounts.id.renderButton(
      signInBtn.current,
      {
        locale: 'en',
        theme: 'outline',
        size: 'large',
        text: 'signup_with',
        logo_alignment: 'center',
        shape: 'circle',
        width,
        click_listener: () => track.firstPageClickSignUpGoogle(),
      } // customization attributes
    );
  }, [onSignup, width]);

  useEffect(() => {
    if (window.google) {
      initializeSignInButton();
    } else {
      const script = document.createElement('script');
      script.src = 'https://accounts.google.com/gsi/client';
      script.async = true;
      script.onload = initializeSignInButton;
      document.head.appendChild(script);
    }
  }, [initializeSignInButton]);

  return (
    <div className="d-flex justify-content-center my-4" id="google-sign-up-button">
      <div ref={signInBtn} />
    </div>
  );
}

export default GoogleSignUpButton;
